<template>
    <div class="fault-cont">
        <item-vault v-for="(item, index) in items" :key="index" :item="item" :keyItem="index"/>
    </div>
</template>

<script>
import ItemVault from "./ItemVault.vue";

export default {
    components: {
        ItemVault
    },
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    created() {
        //
    }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";
</style>
